// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/node_modules/.pnpm/next@16.2.6_@babel+core@7.2_0e4a82a4340e23eaa1927b398f9fa1e4/node_modules/next/dist/esm/client/components/layout-router.js"));
